<template>
  <div :class="`formulate-input-element  formulate-input-element--${context.type}`"
    :data-type="context.type"
  >
    <!-- placeholder="DD/MM/YYYY" -->
    <template v-if="Array.isArray(context.attributes.title)">
      <h2 :key="item" v-for="item in context.attributes.title">
        {{ evaluate(item) }}
      </h2>
    </template>
    <h2 v-else>{{ context.attributes.title }}</h2>
    <template v-if="Array.isArray(context.attributes.description)">
      <p class="description" :key="item" v-for="item in context.attributes.description">
        {{ item }}
      </p>
    </template>
    <p class="description" v-else>{{ context.attributes.description }}</p>
    <a :href="context.attributes.link">{{ context.attributes.linkText }}</a>
    </div>
</template>

<script>

import {mapGetters} from "vuex";

// Note toCurrency is now a re-usable filter, but we need from string here
import { toCurrency as toCurrencyFromStr } from '@/helpers/currencyHelper.js'

export default {
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
        
    }
  },
  watch: {
    model () {
    }
  },
  computed: {
    ...mapGetters({ answers: 'flattenedAnswers', getStep: 'getStep' }),
    model () {
      return this.context.model
    }
  },
  methods: {
    evaluate(text) {

      let replace = {
        sum_insured_default: toCurrencyFromStr(this.answers[this.getStep('plate')].sum_insured_default,0),
        vehicle_initial_sum_insured_amount: toCurrencyFromStr(this.answers[this.getStep('plate')].vehicle_initial_sum_insured_amount,0)
      }

      // search for moustaches
      let m = new RegExp(/[{]{2}\s*(.*?)\s*[}]{2}/, 'i');
      let found = text.match(m);

      if (found !== null && found[1] !== undefined) {
          //console.log( replace[found[1]] );
          if (replace[found[1]] !== undefined) {
            let replaced_text = text.replace(m, replace[found[1]]);
            return replaced_text;
          }
      }

      return text;
    }
  },
}
</script>

<style scoped lang="scss">

  .formulate-input-element--infobox {
    background-color: $info-blue;
    padding: 1.5rem;
    border-radius: 4px;
  }
  h2 {
    font-size:1.25rem;
  }

  p.description {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  a:link {
    text-decoration: underline;
  }

</style>